import React from 'react';
import '../../styles/pages.css';

const TermsOfUsePage = () => {
  return (
    <div className="static-page">
      <h2 className="page-title">Termos e Condições de Uso</h2>

      <p className="last-updated"><strong>Última atualização:</strong> 24 de novembro de 2025</p>

      <p>Bem-vindo(a) à <strong>Gabrielly Semijoias</strong>!</p>
      <p>Ao acessar e usar nosso site, <a href="https://gabriellysemijoias.com">https://gabriellysemijoias.com</a>, você concorda em cumprir e estar vinculado aos seguintes termos e condições de uso. Por favor, leia-os com atenção.</p>

      <section>
        <h3>1. Uso do Site</h3>
        <ul>
          <li>Você concorda em usar este site apenas para fins legais e de maneira que não infrinja os direitos de, restrinja ou iniba o uso e gozo deste site por terceiros.</li>
          <li>O conteúdo das páginas deste site é para sua informação geral e uso apenas. Ele está sujeito a alterações sem aviso prévio.</li>
        </ul>
      </section>

      <section>
        <h3>2. Contas de Usuário</h3>
        <ul>
          <li>Para acessar certas funcionalidades, como finalizar uma compra, você pode ser solicitado a criar uma conta.</li>
          <li>Você é responsável por manter a confidencialidade de sua conta e senha e por restringir o acesso ao seu computador. Você concorda em aceitar a responsabilidade por todas as atividades que ocorram sob sua conta ou senha.</li>
          <li>Reservamo-nos o direito de recusar serviço, encerrar contas, remover ou editar conteúdo, ou cancelar pedidos a nosso critério exclusivo.</li>
        </ul>
      </section>

      <section>
        <h3>3. Produtos e Preços</h3>
        <ul>
          <li>Fazemos todos os esforços para exibir com a maior precisão possível as cores e imagens de nossos produtos. Não podemos garantir que a exibição de qualquer cor no monitor do seu computador seja precisa.</li>
          <li>Todos os preços dos produtos estão sujeitos a alterações sem aviso prévio.</li>
          <li>Reservamo-nos o direito de, a qualquer momento, modificar ou descontinuar um produto sem aviso prévio.</li>
        </ul>
      </section>

      <section>
        <h3>4. Pedidos e Pagamentos</h3>
        <ul>
          <li>A finalização de um pedido constitui uma oferta de compra de um produto. Todos os pedidos estão sujeitos à nossa aceitação.</li>
          <li>Reservamo-nos o direito de recusar qualquer pedido que você fizer conosco. Podemos, a nosso critério, limitar ou cancelar as quantidades compradas por pessoa, por domicílio ou por pedido.</li>
          <li>O pagamento deve ser recebido por nós antes da nossa aceitação do seu pedido. Utilizamos gateways de pagamento seguros para processar as transações.</li>
        </ul>
      </section>

      <section>
        <h3>5. Propriedade Intelectual</h3>
        <ul>
          <li>Este site contém material que é de nossa propriedade ou licenciado para nós. Este material inclui, mas não está limitado a, design, layout, aparência, aparência e gráficos, bem como o nome da marca e logotipo "Gabrielly Semijoias".</li>
          <li>A reprodução de qualquer conteúdo é proibida, exceto em conformidade com o aviso de direitos autorais, que faz parte destes termos e condições.</li>
        </ul>
      </section>

      <section>
        <h3>6. Limitação de Responsabilidade</h3>
        <ul>
          <li>A Gabrielly Semijoias não será responsável por quaisquer danos diretos, indiretos, incidentais, especiais ou consequenciais que resultem do uso ou da incapacidade de usar nosso site ou produtos.</li>
          <li>Nem nós nem quaisquer terceiros fornecemos qualquer garantia quanto à precisão, pontualidade, desempenho, integridade ou adequação das informações e materiais encontrados ou oferecidos neste site para qualquer finalidade específica.</li>
        </ul>
      </section>

      <section>
        <h3>7. Lei Aplicável</h3>
        <p>Estes termos e condições são regidos e interpretados de acordo com as leis do Brasil e você se submete irrevogavelmente à jurisdição exclusiva dos tribunais desse país.</p>
      </section>

      <section>
        <h3>8. Contato</h3>
        <p>Para quaisquer dúvidas sobre estes Termos de Uso, entre em contato conosco pelo e-mail: <strong>contato@gabriellysemijoias.com</strong>.</p>
      </section>
    </div>
  );
};

export default TermsOfUsePage;
